import React, { useState, useEffect}  from 'react';
import { PostRequest } from 'components/common/index.js';
import { CanDownload, NeedsToConfirmEmail, LogInRequired, BuyAndDownload } from 'components/layout/download_buttons/index.js';

const LayoutDownloadButtonsSection = ({}) => {
  const [mode, setMode] = useState('none');
  const [statusFetched, setStatusFetched] = useState(false);

  const [loggedIn, setLoggedIn] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  // Nesting downloads are Business-only (plus Credit Pack buyers and the demo). A
  // non-entitled user gets the "Buy & Download" call-to-action instead of the
  // DXF/SVG/PDF buttons. Defaults false (least-privileged): nothing renders until
  // statusFetched, so this only decides the fail-safe if the status call never
  // returns the flag.
  const [canDownloadNesting, setCanDownloadNesting] = useState(false);

  const [promptForCreateAccountEmail, setPromptForCreateAccountEmail] = useState('');

  const delayGetStatus = 500;
  const [quoteBuilderEnabled, setQuoteBuilderEnabled] = useState(false);

  const getStatus = () => {
    const timeOutId = setTimeout(getStatusAction, delayGetStatus);
    return () => clearTimeout(timeOutId);
  }

  const getStatusAction = (onStatusFetched) => {
    let data = { drawing_id: window.drawingId };
    if (window.currentDrawingOptions != undefined) {
      data = Object.assign({}, window.currentDrawingOptions, { drawing_id: window.drawingId });
      data.formula_options_present = true
    }

    PostRequest({
      url: '/layouts-button-status/',
      data: data,
      callback: ( data ) => {
        setLoggedIn( _prev => data.logged_in )
        setConfirmed( _prev => data.confirmed )
        setCanDownloadNesting( _prev => data.can_download_nesting )
        setQuoteBuilderEnabled( _prev => data.quote_builder_enabled )
        setStatusFetched( () => true );
        if(data.omniauth_sign_in_failed_account_does_not_exists) {
          setPromptForCreateAccountEmail(() => data.omniauth_email)
        }

        if(onStatusFetched != undefined) { onStatusFetched() }
      }
    })
  }

  useEffect( () => {
    let listen = 'nesting.downloads_buttons_refresh_required';
    document.addEventListener(listen, getStatus);
    return () => { document.removeEventListener(listen, getStatus);}
  }, [])

  useEffect(getStatus, [])

  const onLoginSuccess = () => {
    getStatusAction(() => {
      setTimeout(enableDownloadButtons, delayGetStatus);
    });
  }

  //render starts here, no code below
  if(!statusFetched) {
    return;
  }

  return (
    <div>
      {!loggedIn && (
        <div className="float-right">
          <LogInRequired mode={mode} setMode={setMode} promptForCreateAccountEmail={promptForCreateAccountEmail} callback={onLoginSuccess} />
        </div>
      )}

      {loggedIn && confirmed && canDownloadNesting && (
        <div className="float-right">
          <CanDownload quoteBuilderEnabled={quoteBuilderEnabled} />
        </div>
      )}

      {loggedIn && confirmed && !canDownloadNesting && (
        <div className="float-right">
          <BuyAndDownload />
        </div>
      )}

      {loggedIn && !confirmed && (
        <div className="float-right">
          <NeedsToConfirmEmail onSuccess={getStatus} />
        </div>
      )}

    </div>
  )
}

export default LayoutDownloadButtonsSection;
